import { AbstractControl } from '@angular/forms';
export function syncFormControlDisabledState(
    control: AbstractControl | null | undefined,
    disabled: boolean | undefined | null
): void {
    if (!control) {
        return;
    }

    if (disabled) {
        if (control.enabled) {
            control.disable({ emitEvent: false });
        }
    }
    else if (control.disabled) {
        control.enable({ emitEvent: false });
    }
}
